<template>
  <div class="page page-moviegoers">
    <!-- 头部导航 -->
    <header class="header">
      <div class="nav-left">
        <div class="back-btn el-icon-arrow-left" @click="goBack"></div>
      </div>
      <div class="nav-center">
        <h1 class="page-title">观影人</h1>
      </div>
    </header>
    <!-- 添加观影人区域 -->
    <div class="add-moviegoer-section">
      <div class="add-btn" @click="showAddDialog">
        <div class="add-icon">+</div>
        <span class="add-text">添加观影人</span>
      </div>
    </div>

    <!-- 观影人列表 -->
    <div class="moviegoers-list">
      <div v-for="(moviegoer, index) in moviegoers" :key="index" class="moviegoer-card">
        <div class="moviegoer-info">
          <div class="moviegoer-name">{{ moviegoer.name }}</div>
          <div class="moviegoer-phone">{{ moviegoer.phone }}</div>
        </div>
        <div class="action-icons">
          <div class="edit-icon" @click="editMoviegoer(index)">
            <i class="el-icon-edit"></i>
          </div>
          <div class="delete-icon" @click="deleteMoviegoer(index)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-if="moviegoers.length === 0">
      <div class="empty-icon el-icon-user-solid"></div>
      <div class="empty-text">暂无观影人</div>
    </div>
    <!-- 添加/编辑观影人对话框 -->
    <el-dialog
      :title="isEditing ? '编辑观影人' : '添加观影人'"
      :visible.sync="dialogVisible"
      width="90%"
      :close-on-click-modal="false"
      :modal="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="false"
      class="custom-dialog"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="0">
          <div class="form-group">
            <label class="form-label">姓名</label>
            <el-form-item prop="name">
              <el-input v-model="form.name" placeholder="请输入观影人姓名" class="custom-input"></el-input>
            </el-form-item>
          </div>

          <div class="form-group">
            <label class="form-label">手机号</label>
            <el-form-item prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
                class="custom-input"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="submitForm" class="confirm-btn" v-if="this.isEditing">确认修改</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          class="confirm-btn"
          v-if="!this.isEditing"
        >确认添加</el-button>
      </div>
    </el-dialog>

    <!-- Element UI 删除确认对话框 -->
    <el-dialog
      title="删除确认"
      :visible.sync="deleteDialogVisible"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="delete-confirm-dialog"
    >
      <div class="delete-content">
        <div class="warning-section">
          <i class="el-icon-warning warning-icon"></i>
          <div class="warning-text">
            <p>确定要删除观影人"{{ deleteTarget.name }}"吗？</p>
            <p class="danger-text">删除后无法恢复。</p>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDelete" class="cancel-btn">取消</el-button>
        <el-button type="danger" @click="confirmDelete" class="confirm-btn">确定删除</el-button>
      </div>
    </el-dialog>
    <!-- 页面加载组件 -->
    <div v-if="isLoading" class="page-loading-overlay">
      <div class="page-loading-container">
        <!-- 旋转的圆圈动画 -->
        <div class="page-spinner">
          <div class="page-spinner-inner"></div>
        </div>

        <!-- 加载文字 -->
        <div class="page-loading-text">
          <span class="page-loading-dots">
            <span class="page-dot">.</span>
            <span class="page-dot">.</span>
            <span class="page-dot">.</span>
          </span>
        </div>

        <!-- 可选的加载提示文字 -->
        <div v-if="loadingText" class="page-loading-message">{{ loadingText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  name: "MoviegoersList",
  data() {
    return {
      moviegoers: [],
      // 页面加载状态
      isLoading: false,
      loadingText: "加载中，请稍等",
      dialogVisible: false,
      isEditing: false,
      editingIndex: -1,
      deleteDialogVisible: false,
      deleteTarget: {},
      deleteIndex: -1,
      form: {
        name: "",
        phone: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "姓名长度应在2-10个字符之间",
            trigger: "blur"
          },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z\s]+$/,
            message: "请输入真实姓名，只能包含中文、英文字母和空格",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur"
          }
          // { validator: this.validatePhone, trigger: "blur" }
        ]
      }
    };
  },
  async mounted() {
    await this.searchForViewerInformation();
  },
  methods: {
    async searchForViewerInformation() {
      this.isLoading = true;
      try {
        let data = {
          openid: localStorage.getItem("openid"),
          clientsessionkey: localStorage.getItem("clientSessionKey")
        };
        const response = await api.SearchForViewerInformation(data);
        console.log(response);
        this.moviegoers = [];
        if (response && response.length > 0) {
          this.moviegoers = response.map(item => {
            return {
              id: item.ID,
              name: item.ZuYuanXingMing,
              phone: this.maskPhone(item.LianXiDianHua),
              originalPhone: item.LianXiDianHua
            };
          });
        }
        console.log(this.moviegoers)
      } catch (error) {
        console.error("查询观影人失败:", error);
        this.$message && this.$message.error("查询观影人失败");
      } finally {
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    showAddDialog() {
      this.isEditing = false;
      this.form = {
        name: "",
        phone: ""
      };
      this.dialogVisible = true;
    },
    editMoviegoer(index) {
      this.isEditing = true;
      this.editingIndex = index;
      this.form = {
        name: this.moviegoers[index].name,
        phone:
          this.moviegoers[index].originalPhone || this.moviegoers[index].phone
      };
      this.dialogVisible = true;
    },
    deleteMoviegoer(index) {
      this.deleteTarget = this.moviegoers[index];
      this.deleteIndex = index;
      this.deleteDialogVisible = true;
    },
    cancelDelete() {
      this.deleteDialogVisible = false;
      this.deleteTarget = {};
      this.deleteIndex = -1;
    },
    async confirmDelete() {
      // this.moviegoers.splice(this.deleteIndex, 1);
      // this.deleteDialogVisible = false;
      // this.deleteTarget = {};
      // this.deleteIndex = -1;
      // this.$message.success("删除成功");
      try {
        // const formData = new FormData();
        // formData.append("id", this.moviegoers[this.deleteIndex].id);
        let data = {
          openid: localStorage.getItem("openid"),
          clientsessionkey: localStorage.getItem("clientSessionKey"),
          id: this.moviegoers[this.deleteIndex].id
        };
        await api.DeleteViewerInformation(data).then(async response => {
          console.log(response);
          if (response != 0) {
            this.deleteDialogVisible = false;
            this.$message.success("删除成功");
            this.searchForViewerInformation();
          }
        });
      } catch (error) {
        console.error("修改观影人失败:", error);
        this.$message && this.$message.error("修改观影人失败");
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.isEditing) {
            await this.modifyTheViewer();
          } else {
            console.log(this.form);
            await this.addAViewer();
          }
        }
      });
    },
    async modifyTheViewer() {
      try {
        const formData = new FormData();
        formData.append("id", this.moviegoers[this.editingIndex].id);
        formData.append("xingming", this.form.name);
        formData.append("dianhua", this.form.phone);
        let data = {
          openid: localStorage.getItem("openid"),
          clientsessionkey: localStorage.getItem("clientSessionKey"),
          id: this.moviegoers[this.editingIndex].id,
          xingming: this.form.name,
          dianhua: this.form.phone
        };
        await api.ModifyViewerInformation(data).then(async response => {
          if (response.Code == 400 && response.Message == "组员已经存在") {
            this.$message.warning("请勿重复添加");
          } else if (response == 1) {
            this.dialogVisible = false;
            this.$message.success(this.isEditing ? "修改成功" : "添加成功");
            await this.searchForViewerInformation();
          }
        });
      } catch (error) {
        console.error("修改观影人失败:", error);
        this.$message && this.$message.error("修改观影人失败");
      }
    },
    async addAViewer() {
      try {
        const formData = new FormData();
        formData.append("xingming", this.form.name);
        formData.append("dianhua", this.form.phone);
        let data = {
          xingming: this.form.name,
          dianhua: this.form.phone,
          openid: localStorage.getItem("openid"),
          clientsessionkey: localStorage.getItem("clientSessionKey")
        };
        await api.AddViewerInformation(data).then(async response => {
          if (response.Code == 400 && response.Message == "组员已经存在") {
            this.$message.warning("请勿重复添加");
          } else if (response == 1) {
            this.dialogVisible = false;
            this.$message.success(this.isEditing ? "修改成功" : "添加成功");
            await this.searchForViewerInformation();
          }
        });
      } catch (error) {
        console.error("添加观影人失败:", error);
        this.$message && this.$message.error("添加观影人失败");
      }
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    maskPhone(phone) {
      // 手机号脱敏处理
      if (phone.length === 11) {
        return phone.substring(0, 3) + "****" + phone.substring(7);
      }
      return phone;
    },
    validatePhone(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      // 检查手机号是否重复
      const isDuplicate = this.moviegoers.some((moviegoer, index) => {
        // 如果是编辑模式，排除当前编辑的项
        if (this.isEditing && index === this.editingIndex) {
          return false;
        }
        // 直接比较原始手机号
        return moviegoer.originalPhone === value;
      });

      if (isDuplicate) {
        callback(new Error("该手机号已存在，请使用其他手机号"));
      } else {
        callback();
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    rgba(195, 77, 52, 0.28) 0%,
    rgba(248, 248, 248, 0.08) 100%
  );
  padding: 0;
}

/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.nav-left,
.nav-right {
  width: 40px;
  z-index: 99;
}

.nav-center {
  flex: 1;
  text-align: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 0 -40px;
}

.back-btn,
.share-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  padding: 8px;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

/* 添加观影人区域 */
.add-moviegoer-section {
  padding: 20px 16px;
}

.add-btn {
  display: flex;
  align-items: center;
  background: #c34d34;
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 8px rgba(195, 77, 52, 0.3);
}

.add-btn:hover {
  background: #a63d2a;
}

.add-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 16px;
  font-weight: bold;
}

.add-text {
  font-size: 16px;
  font-weight: 500;
}

/* 观影人列表 */
.moviegoers-list {
  padding: 0 16px 20px;
}

.moviegoer-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.moviegoer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.moviegoer-info {
  flex: 1;
}

.moviegoer-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.moviegoer-phone {
  font-size: 14px;
  color: #666;
}

.action-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-icon,
.delete-icon {
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: color 0.2s, background-color 0.2s;
}

.edit-icon:hover {
  color: #c34d34;
  background-color: rgba(195, 77, 52, 0.1);
}

.delete-icon:hover {
  color: #f56c6c;
  background-color: rgba(245, 108, 108, 0.1);
}
/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 16px;
  color: #666;
}

/* 页面加载组件样式 */
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.page-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  padding: 40px 30px;
  min-width: 200px;
  text-align: center;
}

/* 旋转动画 */
.page-spinner {
  width: 50px;
  height: 50px;
  position: relative;
  margin-bottom: 20px;
}

.page-spinner-inner {
  width: 100%;
  height: 100%;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: pageSpin 1s linear infinite;
}

@keyframes pageSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文字样式 */
.page-loading-text {
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  margin-bottom: 10px;
}

.page-loading-dots {
  display: inline-block;
}

.page-dot {
  animation: pageDotPulse 1.4s infinite ease-in-out;
  animation-fill-mode: both;
}

.page-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.page-dot:nth-child(2) {
  animation-delay: -0.16s;
}

.page-dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes pageDotPulse {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* 加载提示文字 */
.page-loading-message {
  font-size: 14px;
  color: #fff;
  margin-top: 8px;
  max-width: 200px;
  line-height: 1.4;
}
/* 对话框样式 - 强制修复苹果真机问题 */
.custom-dialog {
  /* background: #f8f8f8; */
}

.custom-dialog .el-dialog {
  background: #f8f8f8;
  border-radius: 12px;
  z-index: 10000 !important;
  position: relative;
}

/* iOS Safari 弹窗层级修复 */
.custom-dialog .el-dialog__wrapper {
  z-index: 10000 !important;
}

.custom-dialog .el-dialog__header {
  z-index: 10001 !important;
  position: relative;
}

.custom-dialog .el-dialog__body {
  z-index: 10001 !important;
  position: relative;
}

.custom-dialog .el-dialog__footer {
  z-index: 10001 !important;
  position: relative;
}

/* 强制修复苹果真机蒙层问题 */
.custom-dialog .el-dialog__wrapper::before {
  display: none !important;
}

.custom-dialog .el-dialog__wrapper::after {
  display: none !important;
}

/* 移除可能的遮罩层 */
.custom-dialog .el-dialog__wrapper .el-overlay {
  display: none !important;
}

/* 确保弹窗内容在最上层 */
.custom-dialog .el-dialog__wrapper {
  background: rgba(0, 0, 0, 0.5) !important;
}

.custom-dialog .el-dialog {
  position: relative !important;
  z-index: 10001 !important;
  pointer-events: auto !important;
}

/* 全局修复苹果真机弹窗蒙层问题 */
body .el-dialog__wrapper {
  z-index: 10000 !important;
}

body .el-dialog {
  z-index: 10001 !important;
  pointer-events: auto !important;
}

body .el-dialog__wrapper .el-overlay {
  z-index: 9999 !important;
}

/* 强制移除所有可能的遮罩层 */
body .el-dialog__wrapper * {
  pointer-events: auto !important;
}

/* 确保弹窗内容可以交互 */
body .el-dialog__body {
  pointer-events: auto !important;
  z-index: 10002 !important;
  position: relative !important;
}

body .el-dialog__body * {
  pointer-events: auto !important;
  z-index: 10003 !important;
  position: relative !important;
}

/* 苹果真机终极修复方案 */
@media screen and (-webkit-min-device-pixel-ratio: 2) {
  /* 检测苹果设备 */
  .custom-dialog .el-dialog__wrapper {
    z-index: 10000 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, 0.5) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .custom-dialog .el-dialog {
    z-index: 10001 !important;
    position: relative !important;
    margin: 0 !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
    border-radius: 12px !important;
  }

  .custom-dialog .el-dialog__body {
    z-index: 10002 !important;
    position: relative !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
  }

  .custom-dialog .el-dialog__body * {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  /* 强制移除所有遮罩层 */
  .custom-dialog .el-dialog__wrapper::before,
  .custom-dialog .el-dialog__wrapper::after {
    display: none !important;
  }

  .custom-dialog .el-dialog__wrapper .el-overlay {
    display: none !important;
  }
}

.custom-dialog .el-dialog__header {
  background: #f8f8f8;
  border-bottom: none;
  padding: 20px 20px 0;
}

.custom-dialog .el-dialog__body {
  background: #f8f8f8;
  padding: 20px;
}

.dialog-content {
  background: #f8f8f8;
}

.form-group {
  margin-bottom: 20px;
}

.form-group .el-form-item {
  margin-bottom: 0;
}

.form-group .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.form-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.custom-input .el-input__inner {
  border-radius: 8px;
  border: 1px solid #ddd;
  height: 48px;
  font-size: 16px;
  padding: 0 16px;
  background: white;
}

.custom-input .el-input__inner:focus {
  border-color: #c34d34;
  box-shadow: 0 0 0 2px rgba(195, 77, 52, 0.1);
}

/* iOS Safari 输入框交互修复 */
.custom-dialog .el-input__inner {
  z-index: 10002 !important;
  position: relative !important;
  -webkit-user-select: text !important;
  user-select: text !important;
  pointer-events: auto !important;
}

.custom-dialog .el-form-item {
  z-index: 10002 !important;
  position: relative !important;
}

.custom-dialog .el-form-item__content {
  z-index: 10002 !important;
  position: relative !important;
}

.dialog-footer {
  text-align: center;
  padding: 20px;
  background: #f8f8f8;
  border-top: none;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #c34d34;
  color: #c34d34;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  margin-right: 12px;
}

.cancel-btn:hover {
  background: rgba(195, 77, 52, 0.1);
}

.confirm-btn {
  background: #c34d34;
  border: 1px solid #c34d34;
  color: white;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
}

.confirm-btn:hover {
  background: #a63d2a;
  border-color: #a63d2a;
}

/* Element UI 删除确认对话框样式 */
.delete-confirm-dialog .el-dialog {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}

.delete-confirm-dialog .el-dialog__wrapper {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 2000 !important;
}

.delete-confirm-dialog .el-dialog__header {
  border-bottom: 1px solid #f0f0f0;
  padding: 20px 20px 16px;
}

.delete-confirm-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.delete-confirm-dialog .el-dialog__body {
  padding: 20px;
}

.delete-content {
  text-align: center;
}

.warning-section {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
}

.warning-icon {
  font-size: 24px;
  color: #f56c6c;
  margin-top: 2px;
}

.warning-text p {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

.danger-text {
  color: #f56c6c;
  font-size: 14px;
  font-weight: 500;
}

.delete-confirm-dialog .dialog-footer {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
}

.delete-confirm-dialog .cancel-btn {
  background: transparent;
  border: 1px solid #ddd;
  color: #666;
  border-radius: 8px;
  margin-right: 12px;
}

.delete-confirm-dialog .cancel-btn:hover {
  background: #f5f5f5;
  border-color: #ccc;
}

.delete-confirm-dialog .confirm-btn {
  border-radius: 8px;
  padding: 10px 20px;
}

/* 桌面端大屏幕适配 */
@media (min-width: 1200px) {
  .delete-confirm-dialog .el-dialog {
    width: 400px !important;
    max-width: 400px !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
  }
}

/* 确认对话框居中样式 */
.el-message-box {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  z-index: 3000 !important;
}

.el-message-box__wrapper {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 100vh !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 2000 !important;
}

/* 平板端适配 */
@media (max-width: 1024px) and (min-width: 769px) {
  .delete-confirm-dialog .el-dialog {
    width: 60% !important;
    max-width: 500px !important;
    margin: 0 !important;
  }

  .delete-confirm-dialog .el-dialog__header {
    padding: 18px 20px 14px;
  }

  .delete-confirm-dialog .el-dialog__body {
    padding: 18px 20px;
  }

  .delete-confirm-dialog .dialog-footer {
    padding: 14px 20px 18px;
  }
}

/* iOS Safari 特殊修复 - 更强力的修复方案 */
@supports (-webkit-touch-callout: none) {
  /* 修复弹窗遮罩层 */
  .custom-dialog .el-dialog__wrapper {
    z-index: 10000 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, 0.5) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: auto !important;
  }

  /* 修复弹窗主体 */
  .custom-dialog .el-dialog {
    z-index: 10001 !important;
    position: relative !important;
    margin: 0 !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
    border-radius: 12px !important;
  }

  /* 修复弹窗头部 */
  .custom-dialog .el-dialog__header {
    z-index: 10002 !important;
    position: relative !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
  }

  /* 修复弹窗内容区域 */
  .custom-dialog .el-dialog__body {
    z-index: 10002 !important;
    position: relative !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
    -webkit-user-select: text !important;
    user-select: text !important;
  }

  /* 修复弹窗底部 */
  .custom-dialog .el-dialog__footer {
    z-index: 10002 !important;
    position: relative !important;
    pointer-events: auto !important;
    background: #f8f8f8 !important;
  }

  /* 修复表单和输入框 */
  .custom-dialog .el-form {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  .custom-dialog .el-form-item {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  .custom-dialog .el-form-item__content {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  .custom-dialog .el-input {
    z-index: 10004 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  .custom-dialog .el-input__inner {
    z-index: 10004 !important;
    position: relative !important;
    pointer-events: auto !important;
    -webkit-touch-callout: default !important;
    -webkit-user-select: text !important;
    user-select: text !important;
    background: white !important;
  }

  /* 修复按钮 */
  .custom-dialog .el-button {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  /* 确保弹窗内容区域可以交互 */
  .custom-dialog .dialog-content {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  .custom-dialog .dialog-footer {
    z-index: 10003 !important;
    position: relative !important;
    pointer-events: auto !important;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page {
    padding-bottom: 80px;
  }

  .add-moviegoer-section {
    padding: 16px;
  }

  .moviegoers-list {
    padding: 0 16px 16px;
  }

  .moviegoer-card {
    padding: 14px;
    margin-bottom: 10px;
  }

  .moviegoer-name {
    font-size: 15px;
  }

  .moviegoer-phone {
    font-size: 13px;
  }

  /* 移动端确认对话框居中 - 使用更强的选择器 */
  body .el-message-box {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    width: 90% !important;
    max-width: 400px !important;
    z-index: 3000 !important;
  }

  body .el-message-box__wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    padding: 20px !important;
    z-index: 2000 !important;
  }

  body .el-message-box__content {
    text-align: center !important;
  }

  body .el-message-box__btns {
    text-align: center !important;
    margin-top: 20px !important;
  }

  body .el-message-box__btns .el-button {
    width: 80px !important;
    margin: 0 8px !important;
  }

  /* 移动端 Element UI 删除确认对话框 */
  .delete-confirm-dialog .el-dialog {
    width: 80% !important;
    max-width: 300px !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
  }

  .delete-confirm-dialog .el-dialog__wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 2000 !important;
  }

  .delete-confirm-dialog .el-dialog__header {
    padding: 14px 16px 10px;
  }

  .delete-confirm-dialog .el-dialog__title {
    font-size: 15px;
  }

  .delete-confirm-dialog .el-dialog__body {
    padding: 14px 16px;
  }

  .warning-text p {
    font-size: 15px;
  }

  .danger-text {
    font-size: 13px;
  }

  .delete-confirm-dialog .dialog-footer {
    padding: 10px 16px 14px;
  }

  .delete-confirm-dialog .cancel-btn,
  .delete-confirm-dialog .confirm-btn {
    width: 100%;
    padding: 10px 16px;
    font-size: 15px;
  }

  .delete-confirm-dialog .cancel-btn:last-child,
  .delete-confirm-dialog .confirm-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
